import { Link } from "react-router-dom";
import { CATEGORIES } from "@/mocks/categories";

export default function CategoryEntries() {
  return (
    <section>
      <div className="mb-6 flex items-end justify-between gap-4">
        <div>
          <h2 className="flex items-center gap-2.5 font-heading text-xl font-bold text-foreground-950 md:text-2xl">
            <span className="h-6 w-1.5 rounded-full bg-accent-500"></span>
            影视分类
          </h2>
          <p className="mt-1.5 text-sm text-foreground-500">按类型快速进入，找到你想看的内容</p>
        </div>
      </div>

      <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
        {CATEGORIES.map((cat) => (
          <Link
            key={cat.type}
            to={`/category/${cat.type}`}
            className="group relative h-44 overflow-hidden rounded-lg bg-primary-950"
          >
            <img
              src={cat.cover}
              alt={`${cat.label}分类`}
              title={`${cat.label} - WWW.17C`}
              className="h-full w-full object-cover object-top opacity-70 transition-transform duration-500 group-hover:scale-105"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-primary-950/90 via-primary-950/40 to-transparent"></div>
            <div className="absolute inset-0 flex flex-col justify-end p-5">
              <div className="mb-2 flex h-11 w-11 items-center justify-center rounded-md bg-accent-500 text-primary-950">
                <i className={`${cat.icon} text-2xl`}></i>
              </div>
              <h3 className="font-heading text-lg font-bold text-background-50">
                {cat.label}
                <span className="ml-2 text-xs font-normal text-background-300">{cat.englishName}</span>
              </h3>
              <p className="mt-1 line-clamp-2 text-xs leading-relaxed text-background-300">
                {cat.description}
              </p>
            </div>
            <span className="absolute right-5 top-5 flex h-8 w-8 items-center justify-center rounded-full bg-background-50/15 text-background-50 backdrop-blur transition-colors group-hover:bg-accent-500 group-hover:text-primary-950">
              <i className="ri-arrow-right-up-line"></i>
            </span>
          </Link>
        ))}
      </div>
    </section>
  );
}